import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const ScenarioFlowSceneMeta: ComponentMeta = {
  componentName: "ScenarioFlowScene",
  package: "custom",
  title: "场景",
  description: "看板中的场景容器，可拖入流程节点",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "BlockOutlined",
  canHaveChildren: true,
  acceptedChildren: ["ScenarioFlowStep"],
  editorDnd: {
    draggable: true,
    allowedParentNames: ["ScenarioFlowBoard"],
    partialDropRegion: true,
  },
  props: [
    {
      name: "sceneId",
      label: "场景ID",
      type: PropType.STRING,
      group: "数据",
    },
    {
      name: "title",
      label: "场景标题",
      type: PropType.STRING,
      defaultValue: "场景",
      group: "数据",
    },
  ],
  defaultProps: {
    title: "场景",
  },
  npm: {
    package: "@mijalowcode/materials",
    exportName: "ScenarioFlowScene",
  },
  snippet: {
    componentName: "ScenarioFlowScene",
    package: "custom",
    props: {
      sceneId: "scene-1",
      title: "场景1",
    },
  },
};
